import ProfileService from '../services/profile.service'

export const profileModule = {
  namespaced: true,

  state: {
    profiles: [],
    profile: null
  },

  actions: {
    async list ({ commit }) {
      return ProfileService.list().then(
        response => {
          const profileResponse = response.data
          return Promise.resolve(profileResponse)
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async create ({ commit }, criterias) {
      return ProfileService.create(criterias).then(
        response => {
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async edit ({ commit }, criterias) {
      return ProfileService.edit(criterias).then(
        response => {
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async delete ({ commit }, criterias) {
      return ProfileService.delete(criterias).then(
        response => {
        },
        error => {
          return Promise.reject(error.response.data)
        }
      )
    },

    async setProfile ({ commit }, profile) {
      commit('profileSuccess', profile)
    },

    async reset ({ commit }) {
      commit('listReset')
    }
  },

  mutations: {
    listReset (state) {
      state.profiles = []
    },
    profileSuccess (state, profile) {
      state.profile = profile
    }
  }
}
